module.exports = __webpack_public_path__ + "media/hero.35b18d84.mp4";